'use client';

import { FAQ } from '@/components/FAQ';

export interface HVACReplaceFAQsProps {
	testId?: string;
}

const HVACReplaceFAQs = (props: HVACReplaceFAQsProps) => {
	const { testId = 'HVACReplaceFAQs' } = props;

	return (
		<FAQ includeStructuredData testId={testId} className="mb-10 lg:mb-20">
			<FAQ.Title>FAQ</FAQ.Title>
			<FAQ.Block>
				<FAQ.Item>
					<FAQ.Question panelId="1">
						How is HVAC.com different from traditional HVAC dealers?
					</FAQ.Question>
					<FAQ.Answer panelId="1">
						<p>
							We’ve simplified the process. It all starts with a custom quote
							online, based on a few simple questions about your home and HVAC
							system. Our team of experts then reviews your info, identifies a
							solution, and sends an initial HVAC quote online within 1-2
							business days. With your quote in hand, you can talk with your
							Technical Advisor to finalize details and complete a virtual home
							walkthrough. They manage the HVAC installation process to ensure
							everything is installed correctly.
						</p>
						<p>
							You can rest assured that we are your advocates throughout the
							entire HVAC replacement process. Our laser focus is on making sure
							you get the best solution installed at the highest quality level,
							so that your new replacement HVAC system (and comfort) will last
							for years to come.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
				<FAQ.Item>
					<FAQ.Question panelId="2">
						How do you choose which HVAC technicians to partner with?
					</FAQ.Question>
					<FAQ.Answer panelId="2">
						<p>
							We only partner with trustworthy local installers who pass “the
							family test” — folks that we would happily recommend to our own
							friends and family. All of our technicians are professional,
							responsive, and have an impeccable track record of happy customers
							and quality installations.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
				<FAQ.Item>
					<FAQ.Question panelId="3">
						How do you determine the cost to replace an HVAC system?
					</FAQ.Question>
					<FAQ.Answer panelId="3">
						<p>
							We believe everybody deserves a fair deal when installing a new
							HVAC system. And it’s not a zero-sum game; everyone can win here.
							With lower business overhead and by setting reasonable margins,
							we’re able to offer quality HVAC solutions with fair, honest
							pricing.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
				<FAQ.Item>
					<FAQ.Question panelId="4">
						What factors influence HVAC replacement costs?
					</FAQ.Question>
					<FAQ.Answer panelId="4">
						<p>
							The size of your home, the type of system you need, and any
							additional features such as energy efficiency ratings all impact
							the cost of a new HVAC system. Our HVAC quotes are personalized
							based on your home’s specific needs.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
				<FAQ.Item>
					<FAQ.Question panelId="5">
						What financing options are available for HVAC replacement?
					</FAQ.Question>
					<FAQ.Answer panelId="5">
						<p>
							HVAC financing options are available depending on dealer
							availability and your qualifications as a homeowner. Contact us to
							learn more about how we can help make your new HVAC system more
							affordable.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
				<FAQ.Item>
					<FAQ.Question panelId="6">
						What brands and HVAC equipment do you use?
					</FAQ.Question>
					<FAQ.Answer panelId="6">
						<p>
							We only work with top brands like Trane, American Standard,
							RunTru, and Ameristar when installing new HVAC systems. We
							collaborate closely with homeowners and installers to find the
							best solution for your needs. Our focus is on providing reliable
							and durable equipment that will last for years to come.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
				<FAQ.Item>
					<FAQ.Question panelId="7">
						How do I get an HVAC replacement quote online?
					</FAQ.Question>
					<FAQ.Answer panelId="7">
						<p>
							It’s simple! Answer a few questions about your home and current
							HVAC system from the comforts of your home computer, and our team
							of experts will create a customized quote for you within 1-2
							business days.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
				<FAQ.Item>
					<FAQ.Question panelId="8">
						How do I know if my HVAC system needs to be replaced or just
						repaired?
					</FAQ.Question>
					<FAQ.Answer panelId="8">
						<p>
							It can be difficult to determine whether to repair or replace your
							current HVAC system. However, if your unit is over 10-15 years
							old, requires frequent repairs, or has become less efficient, it
							might be time for a replacement. We can help you evaluate your
							options with a no-pressure consultation.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
				<FAQ.Item>
					<FAQ.Question panelId="9">
						Can I skip the initial home visit for an HVAC replacement?
					</FAQ.Question>
					<FAQ.Answer panelId="9">
						<p>
							Yes, of course! With our digital process, you can skip the initial
							home visit. You’ll receive an accurate quote and replacement plan
							based on the information you provide online, saving you time.
						</p>
					</FAQ.Answer>
				</FAQ.Item>
			</FAQ.Block>
		</FAQ>
	);
};

export default HVACReplaceFAQs;
